module.exports = __webpack_public_path__ + "static/media/asikt.e1a0e4bc.mp3";